export default "__VITE_ASSET__BkC486oL__"